import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class StockMasterServices {
     /**
      *
      * @param payload
      * @return data
      */
     getBatches = async (payload) => {
       const batches = await Helpers.post({
         url: Constants.STOCK_MASTER,
         data: payload,
       });
       return batches;
     }

     /**
      *
      * @param payload
      * @return data
      */
     updateBatches = async (payload) => {
       const updatebatches = await Helpers.put({
         url: Constants.STOCK_MASTER_UPDATE,
         data: payload,
       });
       return updatebatches;
     }

       adjustBatches = async (payload) => {
         const adjustBatches = await Helpers.put({
           url: Constants.ADJUSTMENT_BATCH,
           data: payload,
         });
         return adjustBatches;
       }

     /**
      *
      * @param payload
      * @return data
      */
     deleteBatches = async (payload) => {
       const deleteBatches = await Helpers.put({
         url: Constants.STOCK_MASTER_ARCHIVE,
         data: payload,
       });
       return deleteBatches;
     }

     getProductList = async (tenantId, skuListId, keyword, page, limit) => {
      let url = `${Constants.SKU_LIST}?`;
      if(tenantId) url += `tenant_id=${tenantId}&`;
      if(skuListId) url += `sku_list_id=${skuListId}&`;
      if(keyword) url += `search_keyword=${keyword}&`;
      if(page) url += `page=${page}&`;
      if(limit) url += `limit=${limit}&`;
      const productLists = await Helpers.get({ url });
      return productLists;
     }

     createProductList = async (payload) => {
      const productList = await Helpers.post({
        url: Constants.SKU_LIST,
        data: payload,
      });
      return productList;
    }

    updateProductList = async (payload) => {
      const productList = await Helpers.put({
        url: Constants.SKU_LIST,
        data: payload,
      });
      return productList;
    }

    addProductToList = async (payload) => {
      const productList = await Helpers.post({
        url: `${Constants.SKU_LIST}/add_product`,
        data: payload,
      });
      return productList;
    }

    removeProductFromList = async (payload) => {
      const productList = await Helpers.put({
        url: `${Constants.SKU_LIST}/delete_product`,
        data: payload,
      });
      return productList;
    }
}

export default new StockMasterServices();
